import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatrixODCameraService {

  public cameraDataSubjet = new BehaviorSubject<any>(undefined);
  subjetdDataCamera$ = this.cameraDataSubjet.asObservable();

  public cameraDataActive = new BehaviorSubject<any>(undefined);
  dataCameraActive$ = this.cameraDataActive.asObservable();

  public cameraFilter = new BehaviorSubject<any>(undefined);
  dataCamerFilter$ = this.cameraFilter.asObservable();

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ){ }

  public getCameraFromPointCamera(bodyRequest:any):Observable<any> {
    return this.httpClient.post(`${this.environment.camerasUrl}/camera/matrix-data/format-geo-json`, bodyRequest);
  }
}
